import { Expose } from "class-transformer";

export class OptionModel {
  constructor() {
    this.text = "";
    this.value = "";
  }

  @Expose({ name: "optionText" })
  text: string;

  @Expose({ name: "optionValue" })
  value: string | number;
}

export class OptionRegionModel {
  constructor() {
    this.value = 0;
    this.text = "";
  }

  @Expose({ name: "regionId" })
  value: number;

  @Expose({ name: "regionName" })
  text: string;
}
